import isBlank from "@sedan-utils/is-blank";
import { FuncResponse, FuncResponseType, FunctionBase, } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "./FunctionUtil";
import { GlobalContextData } from "../../api/globalContextTyped/GlobalContext";
import { StoryNodeDisplayType } from "../domain/StoryNodeDisplayType";
import { StoryNodeType } from "../../storyV2/domain/StoryNodeType";
import { SubStory } from "../../storyV2/domain/SubStory";
export class GlobalContextFunction extends FunctionBase {
    constructor(brainClient, authStore, meStore) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.meStore = meStore;
    }
    async run(input, identityInfo, variableList = [], page = 1, next = undefined, pagination = undefined, requestParams = {}, checkAbort, sourceNodeType = StoryNodeDisplayType.TEXT, queries = [], blueprintJSON = "", graphData) {
        const context = await this.brainClient.openAi
            .globalContext(input, graphData, FunctionUtil.createAbortUuid(identityInfo))
            .then(res => {
            return res.data;
        })
            .catch(error => {
            console.error(error);
            return new GlobalContextData();
        });
        const update_querys = context.query.map(item => (isBlank(item.updated_q) ? item.content : item.updated_q));
        return new FuncResponse(FuncResponseType.STRING_GROUP, update_querys);
    }
    /**
     * 满足条件会将StoryNode.content改为从api获取的新数据
     * @param story
     * @param sourceNode
     * @param edge
     */
    async updateSourceContentForStory(story, sourceNode, edge) {
        if (story instanceof SubStory) {
            return Promise.resolve();
        }
        return this.updateSourceContent(sourceNode, FunctionUtil.createFuncRunIdentityInfo(story, edge), story.graphData);
    }
    /**
     * 提供给subStory使用
     * @param sourceNode
     * @param identityInfo
     * @param graphData
     */
    async updateSourceContentForSubstory(sourceNode, identityInfo, graphData) {
        return this.updateSourceContent(sourceNode, identityInfo, graphData);
    }
    /**
     * 更新source node的content数据
     * @param sourceNode
     * @param identityInfo
     * @param graphData
     * @private
     */
    async updateSourceContent(sourceNode, identityInfo, graphData) {
        const children = sourceNode.children ?? [];
        const needRequestQuery = await this.needExecuteGlobalContext(sourceNode);
        // 不符合requestNewQuery的情况那么就直接返回不做处理
        if (!needRequestQuery) {
            return Promise.resolve();
        }
        const update_querys = (await this.run(identityInfo.edgeId, identityInfo, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, graphData)).data;
        if (!isBlank(update_querys)) {
            // 是组的话，更改子视图content
            if (sourceNode.options.type === StoryNodeType.CUSTOMGROUP) {
                children.forEach((child, index) => {
                    child.originContent = child.content;
                    child.content = update_querys[index] ?? child.content;
                });
            }
            else {
                sourceNode.originContent = sourceNode.content;
                sourceNode.content = update_querys[0] ?? sourceNode.content;
            }
        }
        return Promise.resolve();
    }
    /**
     * 判断是否有权限执行globalContext
     * @param sourceNode
     * @private
     */
    async needExecuteGlobalContext(sourceNode) {
        const children = sourceNode.children ?? [];
        const groupPermission = await this.meStore.hasGlobalContextPermission();
        const generalPermission = await this.meStore.hasGlobalContextGeneralPermission();
        if (sourceNode.options.type === StoryNodeType.CUSTOMGROUP) {
            return ((groupPermission || generalPermission) &&
                children.length > 0 &&
                children[0].options.displayType === StoryNodeDisplayType.TEXT);
        }
        return generalPermission && sourceNode.options.displayType === StoryNodeDisplayType.TEXT;
    }
}
